const MONEY_CURRENCY = 'USD';
const cachedByLocale = (make)=>{
    const cache = new Map();
    return (locale)=>{
        const cached = cache.get(locale);
        if (cached != null) {
            return cached;
        }
        const created = make(locale);
        cache.set(locale, created);
        return created;
    };
};
const moneyFormatter = cachedByLocale((locale)=>new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: MONEY_CURRENCY
    }));
const rateFormatter = cachedByLocale((locale)=>new Intl.NumberFormat(locale, {
        style: 'percent',
        maximumFractionDigits: 1
    }));
const syncDateFormatter = cachedByLocale((locale)=>new Intl.DateTimeFormat(locale, {
        dateStyle: 'medium',
        timeZone: 'UTC'
    }));
export const formatMoney = (amount, locale)=>moneyFormatter(locale).format(amount);
export const formatRate = (rate, locale)=>rateFormatter(locale).format(rate);
export const formatSyncDate = (isoTimestamp, locale)=>syncDateFormatter(locale).format(new Date(isoTimestamp));
